(() => {
	angular.module('main').directive('workflowOptions', workflowOptions);

	workflowOptions.$inject = ['$location', 'workflowService'];

	function workflowOptions($location, workflowService) {
		return {
			restrict: 'E',
			scope: {
				task: '=',
				taskList: '='
			},
			template: ` 
                     <div class="flex-row workflow-options">
                        <btn-edit class="m-5 pt-5 pb-5 w-40" sn-empty="true" ng-disabled="task.disabled" ng-click="showEditTaskModal(task, taskList)"></btn-edit>
                        <btn-delete class="m-5 pt-5 pb-5 w-40" sn-empty="true" ng-disabled="task.disabled" ng-click="showDeleteTaskModal(task, taskList)"></btn-delete>
                     </div>
                    `,
			replace: true,
			transclude: true,
			link(scope) {
				scope.showDeleteTaskModal = (task, taskList) => {
					workflowService.setTaskInfo(task, taskList);
					$('#deleteWorkflowTaskModal').modal('show');
				};

				scope.showEditTaskModal = (task, taskList) => {
					workflowService.setTaskInfo(task, taskList, true);
					scope.tickTask = false;
					scope.tickTaskType = '';
					const isTemplate = $location.path().includes('/settings');
					const modalId = workflowService.chooseModalToShow(task, isTemplate);
					$(modalId).modal('show');
				};
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Workflow/buttons/workflowOptions.js